import api, { cardeal } from './api';

export class CaminhosPDFService {
  getOpcaoInstituto = async (matricula) => {
    const response = await cardeal.get('ObterOpcaoInstituto', {
      params: {
        matricula,
      },
      responseType: 'arraybuffer',
    });
    return response;
  };

  getInformeRendimento = async (matricula, token, ano) => {
    try {
      const response = await api.get('ObterInformeRendimentoParticipante', {
        params: {
          matricula,
          token,
          ano,
        },
        responseType: 'arraybuffer',
      });
      return response;
    } catch (error) {
      return { error: 'Ocorreu um erro ao carregar o arquivo' };
    }
  };

  getInformeRendimentoResgate = async (matricula, token, ano) => {
    try {
      const response = await api.get(
        'ObterInformeRendimentoResgateParticipante',
        {
          params: {
            matricula,
            token,
            ano,
          },
          responseType: 'arraybuffer',
        }
      );
      return response;
    } catch (error) {
      return { error: 'Ocorreu um erro ao carregar o arquivo' };
    }
  };

  gerarDemonstrativoCusteioAdmin = async (matricula, token) => {
    try {
      const response = await api.get('GerarDemonstrativoCusteioAdmin', {
        params: {
          matricula,
          token,
        },
        responseType: 'arraybuffer',
      });

      // if (!window.atob(response.data)) {
      //   return { error: 'Ocorreu um erro ao carregar o arquivo' };
      // }

      return response;
    } catch (error) {
      return { error: 'Ocorreu um erro ao carregar o arquivo' };
    }
  };
}
